export const SOFTWARE_ISSUE_SKELETON_MOUNTED_MARK = 'SOFTWARE_ISSUE_SKELETON_MOUNTED_MARK';
